
  import { defineComponent, ref } from 'vue';
  import { getOrganizationUsersCount } from '@/ui/auth/auth';
  import { pushRoute } from '@/ui/helpers';
  import { SubscriptionSlugNickName } from '@/entities/subscription/constants';
  import { PlanNickName } from '@/entities/plan/constants';
  import { startTrial } from '@/services/api/resources/chargebee/subscription/actions';
  import FreeTrialModal from '@/ui/components/modals/FreeTrialModal.vue';

  interface FreePlanBannerProps {
    display?: boolean;
    classes?: string;
  }

  export default defineComponent<FreePlanBannerProps>({
    name: 'FreePlanBanner',
    components: {
      FreeTrialModal,
    },
    props: ['display', 'classes'],
    setup() {
      const showFreeTrialPreviewModal = ref(false);
      const isLoading = ref(false);

      const onUpgradeClick = () => {
        pushRoute({
          name: 'subscribe',
          query: {
            plan: SubscriptionSlugNickName.ProfessionalNew,
            users: getOrganizationUsersCount().toString(),
            interval: PlanNickName.Yearly,
          },
        });
      };

      const onStartTrialClick = async () => {
        showFreeTrialPreviewModal.value = true;
      };

      const onModalClose = async () => {
        showFreeTrialPreviewModal.value = false;
      };

      const startFreeTrial = async () => {
        isLoading.value = true;
        await startTrial()();
        showFreeTrialPreviewModal.value = false;
        isLoading.value = false;
      };

      return {
        onUpgradeClick,
        onStartTrialClick,
        startFreeTrial,
        onModalClose,
        showFreeTrialPreviewModal,
        isLoading,
      };
    },
  });
